import { Input, SelectInput } from "components/__new/common/form";
import ReactSelect from 'react-select';
import { reactSelectStyles } from 'utils/reactSelectStyles';
import { useMemo } from "react";

const CreateEditForm = (props) => {
    const { form, setForm, groupsLoading, groups, banksLoading, banks, pensionProvidersLoading, pensionProvidersData  } = props;
    
    const banksData = useMemo(() => {
        return banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
            label: singleBank?.bankName || singleBank?.institutionName,
            value: singleBank?.bankCode || singleBank?.institutionCode,
        })) || [];
    }, [banks])
    
    return (
        <>
            <div className="font-bold">
                Personal Details
            </div>

            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <Input type="text" label="First Name" placeholder="Enter Employee First Name" required={true} value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} inputClass="capitalize" />
                <Input type="text" label="Last Name" placeholder="Enter Employee Last Name" required={true} value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} inputClass="capitalize" />
                <Input type="tel" label="Phone Number" placeholder="Enter Employee Phone Number" required={true} value={form.phoneNumber} onChange={(e) => setForm({...form, phoneNumber: e.target.value})} />
            </div>

            <div className="mt-4 font-bold">
                Work Details
            </div>

            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <Input type="email" label="Email Address" placeholder="Enter Employee Email Address" required={true} value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} />
                <Input type="text" label="Staff ID (If any)" placeholder="Enter Staff ID Number" value={form.staffId} onChange={(e) => setForm({...form, staffId: e.target.value})} />
                <Input type="text" label="Job Title" placeholder="Enter Employee Job Title" required={true} value={form.jobTitle} onChange={(e) => setForm({...form, jobTitle: e.target.value})} />
                <div>
                    {(groupsLoading === true) && 
                        <Input type="text" label="Employee Group (optional)" value="Loading groups..." disabled={true} />
                    }
                    {(groupsLoading === false) && 
                        <SelectInput label="Employee Group (optional)" value={form.groupPolicyId} onChange={(e) => setForm({...form, groupPolicyId: e.target.value})}>
                            <option value="">Select Group</option>
                            <option value="general-group">General Group</option>
                            {groups?.data?.map(group => (
                                <option key={group.id} value={group.id}>{group.name}</option>
                            ))}
                        </SelectInput>
                    }
                </div>
                <Input type="number" label="Net Monthly Salary" placeholder="Enter Amount" min="1000" step="0.01" required={true} value={form.netMonthlySalary} onChange={(e) => setForm({...form, netMonthlySalary: e.target.value})} />
                <Input type="number" label="Gross Salary (Yearly)" placeholder="Enter Amount" min="1000" step="0.01" value={form.grossAnnualPay} onChange={(e) => setForm({...form, grossAnnualPay: e.target.value})} />
            </div>

            <div className="mt-4 font-bold">
                Bank Details
            </div>

            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    {/* {(banksLoading === true) && 
                        <Input type="text" label="Bank Name" required={true} value="Loading banks..." disabled={true} />
                    }
                    {(banksLoading === false) && 
                        <SelectInput label="Bank Name" required={true} value={form.bankCode} onChange={(e) => setForm({...form, bankCode: e.target.value})}>
                            <option value="">Select Bank</option>
                            {banks?.data?.content?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                                <option key={bank.id} value={bank.institutionCode}>{bank.institutionName}</option>
                            ))}
                        </SelectInput>
                    } */}
                    <p className="text-sm mb-1">Bank Name <span className="form-input-required">*</span></p>
                    <ReactSelect
                        isDisabled={banksLoading}
                        isLoading={banksLoading}
                        isSearchable
                        onChange={(selected) => {
                            setForm({
                                ...form, 
                                bankCode: selected.value,
                            });
                        }}
                        options={banksData}
                        styles={reactSelectStyles}
                        placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                        noOptionsMessage={() => "No Banks Found"}
                    />
                </div>
                <Input type="number" label="Bank Account Number" placeholder="Enter Bank Account Number" required={true} value={form.bankAccountNumber} onChange={(e) => setForm({...form, bankAccountNumber: e.target.value})} />
            </div>

            <div className="mt-4 font-bold font-dm-sans">
                Pension Details
            </div>

            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    <SelectInput disabled={pensionProvidersLoading} label="Pension Provider (Optional)" required={false} value={form.pensionAdministrator || ""} onChange={(e) => setForm({...form, pensionAdministrator: e.target.value})}>
                        <option value="">{pensionProvidersLoading ? "Fetching providers..." : form?.pensionAdministrator?.length ? form?.pensionAdministrator : "Select Provider"}</option>
                        {pensionProvidersData?.data?.map((item) => (
                            <option key={item?.name} value={item?.name}>{item?.name}</option>
                        ))}
                    </SelectInput>
                </div>
                <Input type="text" label="PEN Number (Optional)" placeholder="PEN Number" required={false} value={form.pensionNumber || ""} onChange={(e) => setForm({...form, pensionNumber: e.target.value})} />
                <Input type="number" label="Tax Number (Optional)" placeholder="Enter here" required={false} value={form.taxIdentificationNumber || ""} onChange={(e) => setForm({...form, taxIdentificationNumber: e.target.value})} />
            </div>
        </>
    )
}


export default CreateEditForm;